import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
  bgColor: '#2f3640',
  textColor: 'white',
  accentColor: '#9c88ff',
  cardBgColor: 'rgba(0, 0, 0, 0.5)',
}

export const lightTheme: DefaultTheme = {
  bgColor: 'whitesmoke',
  textColor: 'black',
  accentColor: '#9c88ff',
  cardBgColor: 'white',
}